import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Global Components
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
// @ts-ignore
import RoleTable from 'components/RoleTable';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
// @ts-ignore
import TableCountDropdown from 'components/TableCountDropdown';

// Child Components
// @ts-ignore
import GroupsPagination from './components/GroupsPagination';
// @ts-ignore
import GroupsTableHead from './components/GroupsTableHead';
import GroupsTableRow from './components/GroupsTableRow';

// Selectors
// @ts-ignore
import { selectIds } from './selectors';

interface ConnectedProps {
    ids?: number[];
}

type Props = ConnectedProps;

export class GroupsTable extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { ids } = this.props;

        return (
            <React.Fragment>
                <ResponsiveTable>
                    <RoleTable
                        requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                    >
                        <GroupsTableHead />
                        <Table.Body>
                            {(!ids || !ids.length) && (
                                <Table.Row colSpan="11" textAlign="center">
                                    <Table.Cell
                                        colSpan="11"
                                        className="events-table-cell-padding"
                                    >
                                        There are no groups.
                                    </Table.Cell>
                                </Table.Row>
                            )}
                            {ids &&
                                ids.map(id => (
                                    <GroupsTableRow key={id} groupId={id} />
                                ))}
                        </Table.Body>
                    </RoleTable>
                </ResponsiveTable>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginLeft: 'auto' }}>
                        <TableCountDropdown defaultCount={25} />
                        <GroupsPagination />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    ids: selectIds
});

export default connect(mapStateToProps)(GroupsTable);
